import {useContext} from 'react';

import {UseOfContextWithoutProviderError} from '@/types/errors';
import {DocumentRepositoryContext} from './document-repository-context';

export const useDocumentRepository = () => {
  const context = useContext(DocumentRepositoryContext);

  if (!context) {
    throw new UseOfContextWithoutProviderError('DocumentRepository');
  }

  return context;
};
